const versionReg = /AppVersion\/(\d+(\.\d+)+)/
const deviceIdReg = /DeviceId\/([\da-zA-Z-]+)/
const RefreshIdReg = /RefreshId\/([\da-zA-Z-]+)/

function getValue(ua, Reg) {
  const matchArr = ua.match(Reg)
  if (matchArr && matchArr[1]) {
    return matchArr[1]
  } else {
    return ''
  }
}
function appTest() {
  const ua = window.navigator.userAgent || ''
  return {
    isInWin: ua.includes('Platform/ChatGLM_Win'),
    isInMac: ua.includes('Platform/ChatGLM_Mac'),
    appVersion: getValue(ua, versionReg),
    deviceId: getValue(ua, deviceIdReg),
    refreshId: getValue(ua, RefreshIdReg),
    isMac: /macintosh|mac os x/i.test(ua)
  }
}

const res = appTest() || {}

export const isInWin = res.isInWin
export const isiOS = false
export const isMac = res.isMac
export const isInMac = res.isInMac
export const isInDesktop = isInWin || isInMac
export const isInApp = false
export const appVersion = res.appVersion || '0.0.1'

export const deviceId = res.deviceId
export const refreshId = res.refreshId

export const terminal = isInDesktop ? (isInWin ? 'win' : 'mac') : 'pc'

export const promptSuportVersion = '1.2.0'
export const reportVersion = '1.2.6'
